exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".as-structure {\r\n  -webkit-box-flex: 1;\r\n      -ms-flex: 1 1 auto;\r\n          flex: 1 1 auto;\r\n  position: relative;\r\n}\r\n\r\n.as-charts {\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  overflow: auto;\r\n}\r\n\r\n.as-pie-chart {\r\n  /*width: 18.75rem;\r\n  height: 21.875rem;*/\r\n  max-width: 600px;\r\n  margin: 0 auto;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/buffer-graph/components/assortment-structure.component/assortment-structure.component.css
// module id = ./src/app/buffer-graph/components/assortment-structure.component/assortment-structure.component.css
// module chunks = main